import { createSlice } from '@reduxjs/toolkit';

export interface AclState {
	loading: boolean;
	isLoaded: boolean;
	tree: object;
	loadedAt: number | null;
}

const initialState: AclState = {
	loading: false,
	isLoaded: false,
	tree: {},
	loadedAt: null,
};

export const aclSlice = createSlice({
	name: 'acl',
	initialState,
	reducers: {
		setAclLoading: (state, { payload }) => {
			state.loading = payload;
		},

		setAclTree: (state, { payload }) => {
			state.tree = payload || {};
			state.isLoaded = true;
			state.loading = false;
			state.loadedAt = Date.now();
		},

		setAclLoaded: (state, { payload }) => {
			state.isLoaded = payload;
		},

		resetAcl: state => {
			state.loading = false;
			state.isLoaded = false;
			state.tree = {};
			state.loadedAt = null;
		},
	},
});

export const { setAclLoading, setAclTree, setAclLoaded, resetAcl } =
	aclSlice.actions;

export const selectAclIsLoading = (state: any) => state.acl.loading;
export const selectAclIsLoaded = (state: any) => state.acl.isLoaded;
export const selectAclTree = (state: any) => state.acl.tree;
export const selectAclLoadedAt = (state: any) => state.acl.loadedAt;

export default aclSlice.reducer;
